import { render, staticRenderFns } from "./BankslipWidget.vue?vue&type=template&id=2721fc5c"
import script from "./BankslipWidget.vue?vue&type=script&lang=js"
export * from "./BankslipWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports